import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { authService } from './services';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Playlists from './pages/Playlists';
import PlaylistDetail from './pages/PlaylistDetail';
import PermissionManagement from './pages/PermissionManagement';
import SiteConfig from './pages/SiteConfig/SiteConfig';
import SessionExpiredModal from './components/SessionExpiredModal';
import './styles/App.css';

// Component to verify session validity on route change/app load
const AuthVerifier = () => {
  const location = useLocation();
  const [isSessionExpired, setIsSessionExpired] = React.useState(false);

  useEffect(() => {
    const handleAuthExpired = () => {
      setIsSessionExpired(true);
    };

    window.addEventListener('auth:expired', handleAuthExpired);

    return () => {
      window.removeEventListener('auth:expired', handleAuthExpired);
    };
  }, []);

  useEffect(() => {
    const verifySession = async () => {
      // Only verify if we have a token and we are not already on the login page
      if (authService.isAuthenticated() && location.pathname !== '/login') {
        try {
          await authService.getProfile();
        } catch (error) {
          // 401 errors are handled by the api interceptor in services/api.js
        }
      }
    };

    verifySession();
  }, [location.pathname]);

  const handleCloseModal = () => {
    setIsSessionExpired(false);
    // Clear local storage and redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return <SessionExpiredModal isOpen={isSessionExpired} onClose={handleCloseModal} />;
};

function App() {
  return (
    <SiteSettingsProvider>
      <Router>
        <AuthVerifier />
        <Routes>
          <Route path="/*" element={
            <div className="App">
              <Navbar />
              <Routes>
                <Route path="/" element={<Playlists />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/playlists" element={<Navigate to="/" replace />} />
                <Route path="/playlists/:id" element={<PlaylistDetail />} />
                <Route 
                  path="/admin/permissions" 
                  element={
                    <ProtectedRoute adminOnly={true}>
                      <PermissionManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route
                  path="/admin/site-config"
                  element={
                    <ProtectedRoute adminOnly={true}>
                      <SiteConfig />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </div>
          } />
        </Routes>
      </Router>
    </SiteSettingsProvider>
  );
}

export default App;
